import defensiveCopy from "@/util/defensive-copy";
import { globalStore } from "@/store/store";

export function updateSiteTitle(title: string): void {
  const aiSettings = defensiveCopy(globalStore.aiSettings);
  aiSettings.prompt.businessName = title;
  globalStore.setAiSettings(aiSettings);
}

export function updateSiteDescription(description: string): void {
  const aiSettings = defensiveCopy(globalStore.aiSettings);
  aiSettings.prompt.businessDescription = description;
  globalStore.setAiSettings(aiSettings);
}
